import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_layerSoldout} from "../../../../function/FnBodyLayer";
import {fn_quick_cancel} from "../../../../function/FnBodyDetail";

@observer
class OrderCancelView extends Component {

    render() {

        const { rootStore } = this.props;
        const viewStore = rootStore.viewStore;
        const layerStore = rootStore.layerStore;

        return(
            <div className={"layer_comm layer_common_type "+(layerStore.getLayerOrderCancelView?' layer_open':'')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section_tit_comm">
                            <h1>주문 취소사유 선택</h1>
                        </div>
                        <div className="list_radio_reason">
                            <label
                                onClick={event => {
                                    event.preventDefault();
                                    layerStore.setChangeCancelReason("C0");
                                    fn_quick_cancel(rootStore);
                                }}
                            ><input type="radio" name="cancel" checked={layerStore.getChangeCancelReason === "C0"}
                                onChange={event => layerStore.setChangeCancelReason('C0')}
                            /><span>고객요청</span></label>
                            <label
                                onClick={event => {
                                    event.preventDefault();
                                    layerStore.setChangeCancelReason("C1");

                                    // 네이버, 나이스오더만 품절창 표시
                                    ( viewStore.getOrderDetail.mobileOrderFg==="20" )
                                    ? fn_layerSoldout(rootStore)
                                    : fn_quick_cancel(rootStore);

                                }}
                            ><input type="radio" name="cancel" checked={layerStore.getChangeCancelReason === "C1"}
                                    onChange={event => layerStore.setChangeCancelReason('C1')}
                            /><span>재료소진</span></label>
                            <label
                                onClick={event => {
                                    event.preventDefault();
                                    layerStore.setChangeCancelReason("C2");
                                    fn_quick_cancel(rootStore);
                                }}
                            ><input type="radio" name="cancel" checked={layerStore.getChangeCancelReason==="C2"}
                                    onChange={event => layerStore.setChangeCancelReason('C2')}
                            /><span>가게사정</span></label>
                            <label
                                onClick={event => {
                                    event.preventDefault();
                                    layerStore.setChangeCancelReason("C3");
                                    fn_quick_cancel(rootStore);
                                }}
                            ><input type="radio" name="cancel" checked={layerStore.getChangeCancelReason==="C3"}
                                    onChange={event => layerStore.setChangeCancelReason('C3')}
                            /><span>고객정보 부정확</span></label>
                            <label
                                onClick={event => {
                                    event.preventDefault();
                                    layerStore.setChangeCancelReason("C4");
                                    fn_quick_cancel(rootStore);
                                }}
                            ><input type="radio" name="cancel" checked={layerStore.getChangeCancelReason==="C4"}
                                    onChange={event => layerStore.setChangeCancelReason('C4')}
                            /><span>{rootStore.viewStore.getOrderDetail.orderType == "TABLE" ? "테이블 자리없음" : "주문량 폭주"}</span></label>
                            <label
                                onClick={event => {
                                    event.preventDefault();
                                    layerStore.setChangeCancelReason("C5");
                                    fn_quick_cancel(rootStore);
                                }}
                            ><input type="radio" name="cancel" checked={layerStore.getChangeCancelReason==="C5"}
                                    onChange={event => layerStore.setChangeCancelReason('C5')}
                            /><span>기타</span></label>
                        </div>
                        <div className="btn_close btn_close_comm">
                            <button
                                onClick={event => {
                                    layerStore.setChangeCancelReason("");
                                    layerStore.setLayerOrderCancel(false);
                                }}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OrderCancelView;